export const buildingListFields = [
  { key: "buildingReference", label: "Building Site" },
  { key: "addressLine1", label: "Street" },
  { key: "routeID", label: "Route" },
  { key: "location", label: "Location" },
  { key: "customerID", label: "Customer" },
  { key: "managementID", label: "Management Company" },
  { key: "buildingAdded", label: "Date Added", type: "date" },
  { key: "salesRep", label: "Sales Rep" },
  { key: "agencyID", label: "Agency" },
  { key: "buildingType", label: "Building Type" },
  { key: "dispatchType", label: "Dispatch Type" },
  { key: "buildingStatus", label: "Status" },
];
